import { type Ref } from 'vue'
import { ConsultationSummaryReportService } from '@/services/telehealthApi/ConsultationSummaryReportService'
import { useNoticeStore } from '@/stores/notice'
import { NoticeType } from '@/stores/models/Notice'
import { useI18n } from 'vue-i18n'
import type { ConsultationFilters } from '@/composables/consultation/useCompletedConsultationFilters'

function useSummaryReportExporter(filters: Ref<ConsultationFilters>) {
  const { t } = useI18n()

  async function exportSummaryReports(): Promise<void> {
    try {
      const { file, fileName } =
        await ConsultationSummaryReportService.exportConsultationsSummaryReport({
          filter: {
            createdAt: {
              from: filters.value.selectedRange?.[0]?.toISOString() ?? null,
              to: filters.value.selectedRange.at(-1)?.toISOString() ?? null
            },
            patients: filters.value.selectedPatientsIds
          }
        })
      const blob = new Blob([file], {
        type: 'application/pdf'
      })

      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      document.body.appendChild(a)
      a.click()

      a.remove()
      URL.revokeObjectURL(url)
    } catch (e) {
      useNoticeStore().add({
        type: NoticeType.ERROR,
        message: t('Export failed. Please try again') + '.'
      })
    }
  }

  return {
    exportSummaryReports
  }
}

export default useSummaryReportExporter
